import React, { useEffect, useState } from "react";
import classNames from "classnames"; // Optional if you want helper

const RecentlyViewedList = () => {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("recentlyViewed");
      if (stored) {
        setItems(JSON.parse(stored));
      }
    } catch (err) {
      console.error("Error reading recentlyViewed:", err);
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsOpen(true);
    }
  };

  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className="recently-viewed-container js-nav-popout"
    >
      <div className="recently-viewed__container">
        <button
          // tabIndex="0"
          aria-haspopup="menu"
          aria-expanded={isOpen}
          aria-label="Recently Viewed"
          className="recently-viewed__heading js-nav-toggle"
          id="recently-viewed-toggle">
            Recently Viewed
        </button>
      </div>

      <div
        className={classNames("subnav-list", { "subnav-list--open": isOpen })}
        data-parent="recently-viewed"
        data-number-of-items="20"
      >
        <ul className="subnav-list__container">
          {items.length === 0 ? (
            <li className="subnav-list__item">
                No Recently Viewed Documents
            </li>
          ) : (
            items.map((item) => (
              <li key={item.path} className="subnav-list__item">
                <a
                  className="subnav-list__link"
                  href={item.url}
                  title={item.title}
                >
                  {item.title}
                </a>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default RecentlyViewedList;
